export const LearnColumn = [
  {
    text: "About",
    url: "/about",
  },
  {
    text: "Dashboard",
    url: "/dashboard",
  },
  {
    text: "Library",
    url: "/library",
  },
];

export const ConnectColumn = [
  {
    text: "Register",
    url: "/register",
  },
  {
    text: "Login",
    url: "/login",
  },
  {
    text: "FAQ",
    url: "/faq",
  },
];
